import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: center;
  padding-top: 20px;
  padding-bottom: 100px;
  width: 100%;
  max-width: 66%;
  @media (max-width: 767px) {
    max-width: 100%;
    padding-inline: 16px;
  }

  .checkEmailIcon {
    margin: 0 0 30px;
  }
  .completeCheckYourEmail {
    margin-bottom: 30px;

    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    text-transform: capitalize;
    color: var(--color-link);
    margin: 0 0 30px;
  }
  .completeWeSentAConfirmationEmail {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: var(--color-text-muted);
    margin: 0 0 30px;
  }
`;
